module.exports = __webpack_public_path__ + "img/6.fd86cac1.jpg";